import { Box } from "@chakra-ui/react";

import { IEReservationIntervalElement } from "modules/appointment/types/IEReservationIntervalElement";
import { IAppointmentDetails } from "modules/user/application/types/IAppointmentDetails";
import { useGetQueue } from "../../modules/queues/infrastructure/useGetQueue";

import { Modal } from "components/Modal";
import { ChakraText } from "components/ChakraText";

import { QueueName } from "../Commons/QueueName";
import { GroupName } from "../Commons/GroupName";
import { DateTimeTable } from "../Commons/DateTimeTable";
import { EditUserAppointmentForm } from "./EditUserAppointmentForm";

interface IProps {
  onClose: () => void;
  isOpen: boolean;
  appointment: IAppointmentDetails;
  intervalElement: IEReservationIntervalElement;
}

const EditUserAppointmentConfirmationModal = ({
  onClose,
  isOpen,
  appointment,
  intervalElement,
}: IProps) => {
  const { data: queue } = useGetQueue(
    appointment.queueId!,
    appointment.friendlyUrl
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalHeader={<ChakraText>Potwierdzenie operacji</ChakraText>}
    >
      <ChakraText>Zmiany dokonujesz w ramach:</ChakraText>
      {appointment.queueId && <QueueName queueId={appointment.queueId} />}
      {appointment.groupId && <GroupName groupId={appointment.groupId} />}

      <ChakraText fontWeight="bold" mt={2}>
        Czy na pewno chcesz zmienić termin wizyty?
        <br />
        Termin bieżący zostanie automatycznie anulowany. Niepotwierdzenie
        zmiany terminu spowoduje utratę rezerwacji tj. żaden termin nie będzie
        zarezerwowany.
      </ChakraText>
      <DateTimeTable
        appointment={appointment}
        intervalElement={intervalElement}
      />
      <Box mt={4}>
        <EditUserAppointmentForm
          appointment={appointment}
          isOpen={isOpen}
          intervalElement={intervalElement}
          formFields={queue?.formFields || []}
        />
      </Box>
    </Modal>
  );
};

export { EditUserAppointmentConfirmationModal };
